import { Table } from "antd";
import React, {useState,useEffect} from "react";
import { Link } from "react-router-dom";
import {
  Avatar_01,
  Avatar_02,
  Avatar_05,
  Avatar_09,
  Avatar_10,
  Avatar_11,
  Avatar_12,
  Avatar_13,
  Avatar_16,
  eye,
  laptop,
} from "Routes/ImagePath";
import Select from "react-select";
import { formatDateHandler2 } from "utils/common";

export const EmploymentDetails = ({userData}) => {
  
  const [employmentData, setEmploymentData] = useState([]) 
  const [salaryInfoData, setSalaryInfoData] = useState([])
  console.log(userData, "UUUU")
  useEffect(()=>{
   const emp =  [
      { id: 1, title: "Designation", text: userData?.employment?.position?.name },
      { id: 2, title: "Department", text: userData?.employment?.department?.name  },
      { id: 3, title: "Division", text: userData?.employment?.division?.name  },
      { id: 4, title: "Joining Date", text: formatDateHandler2(userData?.employment?.employment_date) },
      { id: 5, title: "Confirmation Date", text: formatDateHandler2(userData?.employment?.confirmation_date) },
      { id: 6, title: "Position Start Date", text: formatDateHandler2(userData?.employment?.position_start_date)},
  
      { id: 7, title: "Leave Balance", text: userData?.employment?.leave_balance},
      { id: 8, title: "Leave Negative Days", text: userData?.employment?.leave_negative_days },
      { id: 9, title: "Number of Warnings", text: userData?.employment?.no_of_warnings },
      // { id: 10, title: "Employment of spouse", text: "No" },
      { id: 11, title: "Notice Period", text: userData?.employment?.notice_period },
      { id: 12, title: "Notice Period Start Date", text: formatDateHandler2(userData?.employment?.notice_period_start_date)  },
      { id: 13, title: "Termination Date", text: formatDateHandler2(userData?.employment?.termination_date) },
      { id: 14, title: "Grade", text: userData?.employment?.grade?.grade_name || "-" },
  
    ]
    setEmploymentData(emp)
    const salary = [
      { id: 1, title: "Salary Amount", text: userData?.salary?.amount },

    ]
    setSalaryInfoData(salary)

  },[userData])
 


  const columns = [
    {
      title: "#",
      dataIndex: "id",
      sorter: (a, b) => a.id.length - b.id.length,
      width: "10%",
    },

    {
      title: "Name",
      dataIndex: "Name",
      render: (text, record) => (
        <span className="table-avatar">
          <Link to="/profile" className="avatar">
            <img alt="" src={record.image} />
          </Link>
          {text}
        </span>
      ),
      sorter: (a, b) => a.Name.length - b.Name.length,
    },

    {
      title: " AssetID",
      dataIndex: "AssetID",
      sorter: (a, b) => a.AssetID.length - b.AssetID.length,
    },
    {
      title: " AssignedDate",
      dataIndex: "AssignedDate",
      sorter: (a, b) => a.AssignedDate.length - b.AssignedDate.length,
    },

    {
      title: " Assignee",
      dataIndex: "Assignee",
      render: (text, record) => (
        <span className="table-avatar">
          <Link to="/profile" className="avatar">
            <img alt="" src={record.img} />
          </Link>
          {text}
        </span>
      ),
      sorter: (a, b) => a.Assignee.length - b.Assignee.length,
    },

    {
      title: "Action",
      dataIndex: "Action",
      render: (record) => (
        <span className="delete-table me-2">
          <Link to="/user-asset-details" className="table-actions d-flex">
            <img alt="" src={eye} />
          </Link>
        </span>
      ),
      sorter: (a, b) => a.Action.length - b.Action.length,
    },
  ];

  const salerytype = [
    { value: 1, label: "Weekly  Type" },
    { value: 2, label: "Hourly Type" },
    { value: 3, label: "Daily Type" },
    { value: 4, label: "Monthly Type" },
  ];
  const bank = [
    { value: 1, label: "Bank transfer" },
    { value: 2, label: "Check" },
    { value: 3, label: "Cash" },
  ];
  const pf = [
    { value: 1, label: "Yes" },
    { value: 2, label: "No" },
  ];
  const esi = [
    { value: 1, label: "Yes" },
    { value: 2, label: "No" },
  ];
  const rate = [
    { value: 1, label: "1%" },
    { value: 2, label: "2%" },
    { value: 3, label: "3%" },
    { value: 4, label: "4%" },
    { value: 5, label: "5%" },
    { value: 6, label: "6%" },
    { value: 7, label: "7%" },
    { value: 8, label: "8%" },
    { value: 9, label: "9%" },
    { value: 10, label: "10%" },
  ];

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? "#ff9b44" : "#fff",
      color: state.isFocused ? "#fff" : "#000",
      "&:hover": {
        backgroundColor: "#ff9b44",
      },
    }),
  };
  return (
    <>
      <div className="tab-content">
        {/* Projects Tab */}
        <div className="tab-pane fade" id="emp_projects">
        <div className="row">
            <div className="col-md-6 d-flex">
              <div className="card profile-box flex-fill">
                <div className="card-body">
                  <h3 className="card-title">
                    Employment Information{" "}
                    {/* <Link
                      to="#"
                      className="edit-icon"
                      data-bs-toggle="modal"
                      data-bs-target="#personal_info_modal"
                    >
                      <i className="fa fa-pencil" />
                    </Link> */}
                  </h3>
                  <ul className="personal-info">
                    {employmentData.map((item, index) => (
                      <ListItem
                        id={item.id}
                        key={index}
                        title={item.title}
                        text={item.text}
                      />
                    ))}
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-md-6 d-flex">
              <div className="card profile-box flex-fill">
                <div className="card-body">
                  <h3 className="card-title">
                    Salary Information{" "}
                    {/* <Link
                      to="#"
                      className="edit-icon"
                      data-bs-toggle="modal"
                      data-bs-target="#emergency_contact_modal"
                    >
                      <i className="fa fa-pencil" />
                    </Link> */}
                  </h3>
                  <ul className="personal-info">
                    {salaryInfoData.map((item, index) => (
                      <ListItem
                        id={item.id}
                        key={index}
                        title={item.title}
                        text={item.text}
                      />
                    ))}
                  </ul>
                 
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </>
  );
};

export const ListItem = ({ title, text }) => (
  <li>
    <div className="title">{title}</div>
    <div className="text">{text}</div>
  </li>
);
